import { PublicClientApplication } from '@azure/msal-browser';
import { Config } from './config';

export const config = {
	appId: Config.AZURE_APP_ID,
	redirectUri: `${Config.APP_URL}/admin/dashboard`
};

export const msalConfig = {
	auth: {
		authority: 'https://login.microsoftonline.com/common',
		clientId: config.appId,
		redirectUri: config.redirectUri
	},
	cache: {
		cacheLocation: 'localStorage',
		storeAuthStateInCookie: true
	}
};

export const loginRequest = {
	scopes: [
		'User.Read',
		'mailboxsettings.read',
		'mail.read',
		'Mail.Read.Shared',
		'Mail.Send.Shared',
		'Mail.ReadWrite.Shared',
		'calendars.readwrite',
		'User.Read.All',
		'Mail.Send',
		'Mail.ReadWrite'
	]
};

export const graphConfig = {
	graphMeEndpoint: 'Enter_the_Graph_Endpoint_Here/v1.0/me'
};

export const msalInstance = new PublicClientApplication(msalConfig);

const msalReady = msalInstance.handleRedirectPromise().catch(() => null);

export const ensureMsalReady = () => msalReady;
